import React from "react";
import { Link, LinkButton } from "../../misc";
import { HeroSection } from "../../layout";
import * as WebRoutes from "@travellocal/utils/webRoutes";

import "./CountryHeader.scss";

interface CountryHeaderProps {
  /**
   * Country data object
   */
  country: ICountry;
}

/**
 * Header component for the country page.
 *
 * @status development
 */
export const CountryHeader: React.FC<CountryHeaderProps> = ({
  country
}) => {
  return (
    <HeroSection heroImage={country.heroImage} images={country.images} className="has-accent wrap-children">
      <div className="columns is-marginless">
        <div className="column is-two-thirds-tablet is-half-desktop is-paddingless">
          <div className="country-header">
            <nav className="country-header__breadcrumb">
              <span className="text--regular">
                <Link to="/">Home</Link> /{` `}
                <Link to="/destinations">Destinations</Link> /{` `}
                <strong className="text--medium">{country.name}</strong>
              </span>
            </nav>
            <h1 className="heading--1">{country.name} Holidays</h1>
            <p className="heading--4">Tailor-made {country.name} tours created for you by trusted local experts</p>
            <LinkButton
              className="primary-button"
              to={WebRoutes.enquiryForm({ locationSlug: country.slug, campaign: "country-page-header" })}
            >
              Plan my trip
            </LinkButton>
          </div>
        </div>
      </div>
    </HeroSection>
  )
}
